import { getRequest } from '../services/requestHandler';
import { BsgGlove } from '../models';

export const getBsgGloves = async () => {
  const url = 'bsgGlove/getBsgGlove?activeOnly=true';
  const response = await getRequest<BsgGlove>('GetBsgGloves', url);
  return response;
};
